import { createContext, useContext, useEffect, useState, useMemo } from "react";
import translations, { LANGUAGES, DEFAULT_LANGUAGE } from "./translations";

const LanguageContext = createContext(null);
const STORAGE_KEY = "tp-lang";

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return DEFAULT_LANGUAGE;
    const saved = window.localStorage.getItem(STORAGE_KEY);
    if (saved && translations[saved]) return saved;
    return DEFAULT_LANGUAGE;
  });

  const setLang = (code) => {
    if (!translations[code]) return;
    setLangState(code);
    try { window.localStorage.setItem(STORAGE_KEY, code); } catch (_e) { /* ignore */ }
  };

  // Update <html lang> and dir when language changes
  useEffect(() => {
    const cfg = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
    document.documentElement.setAttribute("lang", cfg.code);
    document.documentElement.setAttribute("dir", cfg.dir);
  }, [lang]);

  const value = useMemo(() => {
    const dict = translations[lang] || translations[DEFAULT_LANGUAGE];
    const cfg = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];
    return { lang, setLang, t: dict, dir: cfg.dir, languages: LANGUAGES };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useT() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useT must be used within <LanguageProvider>");
  return ctx;
}
